import { Controller } from "@hotwired/stimulus"
import { Toast } from "bootstrap"

export default class extends Controller {
  static targets = [ "element" ]

  connect() {
    const toast = new Toast(this.elementTarget)
    toast.show();

    setTimeout(() => {
      toast.hide();
    }, 5000);
    console.log('toast controller connected on', this.elementTarget)
  }
}
